import SingleResourceEditForm from './SingleResourceEditForm';
import ResourceBulkOperationForm from './ResourceBulkOperationCard';

const ResourceEditForm = ({ scope }: $TSFixMe) => (
    <>
        <SingleResourceEditForm scope={scope} form="resource-edit-form" />
        <ResourceBulkOperationForm scope={scope} />
    </>
);

export default ResourceEditForm;
